type CapacitorBridge = {
  isNativePlatform?: () => boolean;
  getPlatform?: () => string;
};

type BridgeScope = {
  Capacitor?: CapacitorBridge;
};

/**
 * True only when the native shell has injected `window.Capacitor`.
 * Do not import `@capacitor/core` here — that would put the native branch in the web bundle.
 */
export function nativeBridgePresent(scope?: BridgeScope): boolean {
  const target: BridgeScope | undefined =
    scope ?? (typeof window === "undefined" ? undefined : (window as BridgeScope));
  return target?.Capacitor?.isNativePlatform?.() === true;
}

/** Android or iOS shell only. Web and PWA stay null so they never call the release check. */
export function nativeMobilePlatform(scope?: BridgeScope): "android" | "ios" | null {
  const target: BridgeScope | undefined =
    scope ?? (typeof window === "undefined" ? undefined : (window as BridgeScope));
  if (target?.Capacitor?.isNativePlatform?.() !== true) return null;
  const platform = target.Capacitor.getPlatform?.();
  return platform === "android" || platform === "ios" ? platform : null;
}
